@if (showSearch()) {
  <div class="search-row">
    <wr-search-bar class="grow"
                   [search]="searchText()"
                   (searchChange)="searchTextChange.emit($event)">
    </wr-search-bar>
    @if (addItemClicked.observed && canCreate()) {
      <button nbButton
              status="primary"
              nbTooltip="Neu hinzufügen"
              nbTooltipStatus="primary"
              (click)="addItemClicked.emit()">
        <nb-icon icon="plus-outline" pack="eva"></nb-icon>
      </button>
    }
  </div>
}

@if (items()?.length) {
  <div class="list-view noselect" [nbSpinner]="loading()"
       nbInfiniteList [threshold]="400" [throttleTime]="200" (bottomThreshold)="scrolledToEnd.emit()">
    @for (item of items(); track item) {
      <div class="list-item"
           (click)="selectedChange.emit(item)"
           [class.selected]="selected === item">
        @if (listItemTemplate?.templateRef; as template) {
          <ng-container [ngTemplateOutlet]="template"
                        [ngTemplateOutletContext]="{$implicit: item}">
          </ng-container>
        } @else {
          <nb-alert status="warning">
            No template provided
          </nb-alert>
        }
      </div>
    }
  </div>
} @else if (loading()) {
  <div class="list-loading" [nbSpinner]="true"></div>
} @else {
  <span class="text-hint no-items">
    <nb-icon icon="slash-outline" pack="eva"></nb-icon>
    <span>Keine Einträge gefunden</span>
  </span>
}
